const meta = {
  module: "application",
};

export default [
  {
    path: `/application`,
    name: "application",
    component: () =>
      import(
        /* webpackChunkName: "applications" */ "@/modules/applications/views/index.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/application/edit/:id`,
    name: "application/edit",
    component: () =>
      import(
        /* webpackChunkName: "edit/applications" */ "@/modules/applications/views/index.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/preview`,
    name: "preview",
    component: () =>
      import(
        /* webpackChunkName: "preview" */ "@/modules/applications/views/preview.vue"
      ),
    meta: {
      ...meta,
    },
  },
  // {
  //   path: `/admission-end`,
  //   name: "admission-end",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "admission-end" */ "@/modules/applications/views/admissionEnd.vue"
  //     ),
  //   meta: {
  //     ...meta,
  //   },
  // },
  {
    path: `/has-application`,
    name: "has-application",
    component: () =>
      import(
        /* webpackChunkName: "admission-end" */ "@/modules/applications/views/hasApplication.vue"
      ),
    meta: {
      ...meta,
    },
  },
];
